import React, { useEffect, useState } from 'react'
import ChallengeVideo from './ChallengeVideo'
import { useParams } from 'react-router-dom';
import { cdnPullZoneUrl } from '../services/config/bunnycdn';

const ChallengeVideoPlayer = () => {
    const params = useParams();
    const [videoId, setVideoId] = useState('');

    useEffect(() => {
        // console.log(params.videoId);
        setVideoId(params.videoId);
    },[params.videoId]);
  return (
    <div className='h-full w-full bg-white flex items-center justify-center'>
    <div className='reelplayer_frame shadow h-[560px] overflow-scroll snap-y snap-mandatory scroll-smooth bg-neutral-900 rounded' style={{ aspectRatio:"9/16"}}>
      <ChallengeVideo videoUrl={`https://${cdnPullZoneUrl}/${videoId}/play_360p.mp4`} />
    </div>
    </div>
  )
}

export default ChallengeVideoPlayer